import { HotelApiSearchCriteria } from "@/utils/hotel/hydrateHotelFormSearchFromApi"

function parseSearchId(value: unknown): number | undefined {
  if (value == null || `${value}` === "") return undefined
  const parsed = parseInt(`${value}`, 10)
  return Number.isFinite(parsed) ? parsed : undefined
}

/** searchId changes on every paginated searchHotels response page. */
export function pickPageSearchId(
  payload: unknown,
  searchCriteria?: HotelApiSearchCriteria | null,
): number | undefined {
  if (!payload || typeof payload !== "object") {
    return parseSearchId(searchCriteria?.searchId)
  }

  const raw = payload as Record<string, unknown>
  const pagination =
    raw.pagination && typeof raw.pagination === "object"
      ? (raw.pagination as Record<string, unknown>)
      : null

  return (
    parseSearchId(searchCriteria?.searchId) ??
    parseSearchId(raw.searchId) ??
    parseSearchId(pagination?.searchId)
  )
}

export function attachSearchIdToHotelRecord<T extends Record<string, unknown>>(
  record: T,
  pageSearchId?: number,
): T {
  // searchId is scoped to the searchHotels response page — page value wins over stale record fields.
  const resolved =
    pageSearchId ??
    parseSearchId(record.searchId) ??
    parseSearchId(record.searchHotelId)

  if (resolved == null || record.searchId === resolved) {
    return record
  }

  return {
    ...record,
    searchId: resolved,
  }
}
